import { apiSlice } from "../../apiSlice";
export const solicupoApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    createSolicupo: builder.mutation({
      query: (parameters) => ({
        url: `/Autoriza/Solicupo`,
        method: "POST",
        body: parameters,
      }),
    }),
    getPendingAuthotizations: builder.query({
      query: (parameters) => ({
        url: `/Autoriza/getPendingAuthotizations`,
        method: "GET",
        params: parameters,
      }),
    }),
  }),
});

export const { useCreateSolicupoMutation, useLazyGetPendingAuthotizationsQuery } = solicupoApiSlice;
